import { z } from 'zod';
import { BibleLocationSchema } from '../bible/bible-location.js';
import { StudentSchema } from './student.js';
/**
 * Word selection within an assigned verse — indices into the tokenized
 * verse text (see word-pick utils). Only re-seeds the editor UI; the
 * rendered text lives in readingFragment, which is what the PDF prints.
 */
export const WordSelectionSchema = z.object({
    startWordIndex: z.number().int().nonnegative(),
    wordCount: z.number().int().min(1),
});
/**
 * Student assignment schema - a student's assignment within a study
 */
export const StudentAssignmentSchema = z.object({
    student: StudentSchema,
    reviewQuestion: z.string().nullable(),
    startingLocation: BibleLocationSchema.optional(),
    endingLocation: BibleLocationSchema.optional(),
    readingFragment: z.string().optional(),
    wordSelection: WordSelectionSchema.optional(),
});
//# sourceMappingURL=student-assignment.js.map